import { render, staticRenderFns } from "./ColorChooser.vue?vue&type=template&id=2aeb6e20&scoped=true&"
import script from "./ColorChooser.vue?vue&type=script&lang=js&"
export * from "./ColorChooser.vue?vue&type=script&lang=js&"
import style0 from "./ColorChooser.vue?vue&type=style&index=0&id=2aeb6e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb6e20",
  null
  
)

export default component.exports